import { Component, OnInit, Inject, EventEmitter, Output, Input } from '@angular/core';
import {TranslateService, _} from "@ngx-translate/core";
import AccessControlDailyChartView from "./access-control-daily-chart.component.html";
import { EventsService } from '../../services/events.service';
import { EventGuestsService } from '../../services/event-guests.service';
import { Event } from '../../../../shared/models/events/event.model';
import { LogService } from '../../../../core/services/log.service';
import { EventGuest } from '../../../../shared/models/events/guests/event-guest.model';
import { callback } from 'chart.js/dist/helpers/helpers.core';

@Component({
  selector: 'access-control-daily-chart',
  template: AccessControlDailyChartView,
})
export class AccessControlDailyChartComponent implements OnInit {
  @Output() dateSelect = new EventEmitter<string>();
  @Input() eventId: number;

  data: any;
  options: any;
  labels: string[] = [];

  private event: Event = null;
  private guests: EventGuest[] = [];

  constructor(@Inject(TranslateService) private translate: TranslateService,
              @Inject(EventsService) private eventsService: EventsService,
              @Inject(EventGuestsService) private eventGuestsService: EventGuestsService,
              @Inject(LogService) private logService: LogService) { }

  ngOnInit() {
    this.eventsService.event$.subscribe(event => {
      this.event = event;
      this.reloadEventData();
    });

    if(this.event !== null) {
      this.reloadEventData();
    }

    this.eventsService.getEvent(this.eventId);

    this.eventGuestsService.accesses$.subscribe(guests => {
      this.guests = guests;
      if(this.event !== null) {
        this.guestsReceived();
      }
    });

    this.options = {
      indexAxis: 'y',
      scales: {
        x: {
          stacked: true,
          ticks: {
            callback: (label) => {
              if (Math.floor(label) === label) {
                return label;
              }
            }
          }
        },
        y: {
          stacked: true,
        },
      },
    };
  }

  onDataSelect(event: any) {
    this.dateSelect.emit(this.data.labels[event.element.index]);
  }

  private reloadEventData() {
    const dateFrom = new Date(this.event.date_from!);
    const dateTo = new Date(this.event.date_to!);
    this.labels = [];
    for (let date = dateFrom; date <= dateTo; date.setDate(date.getDate() + 1)) {
      this.labels.push(date.toLocaleDateString('es-ES'));
    }

    if(this.guests.length > 0) {
      this.guestsReceived();
    }
  }

  private guestsReceived() {
    const totalGuests = this.guests.filter(g => g.access_status >= 0).length;
    const guestsByDate: any[] = [];
    this.labels.forEach(label => {
      guestsByDate[label] = {
        arrived: 0, 
        rejectedButHere: 0
      };
    });
    this.guests.forEach(guest => {
      // Check values from EventGuestCheckIn related to the guest
      guest.FK_events_guests_check_in_events_guests.forEach(checkIn => {
        const date = new Date(checkIn.check_in_day).toLocaleDateString('es-ES');
        if(guest.access_status === 1) {
          guestsByDate[date].arrived ++;
        } else if(guest.access_status === 2) {
          guestsByDate[date].rejectedButHere ++;
        }
      });
    });

    let notArrived: number[] = [];
    this.labels.forEach(date => {
      notArrived.push(totalGuests - guestsByDate[date].rejectedButHere - guestsByDate[date].arrived);
    });

    const arrivedData = this.labels.map(label => guestsByDate[label].arrived);
    const rejectedButHereData = this.labels.map(label => guestsByDate[label].rejectedButHere);

    this.data = {
      labels: this.labels,
      datasets: [{
        data: notArrived,
        backgroundColor: ['#ed5565', '#ed5565', '#ed5565'],
        label: this.translate.instant(_('dashboard.guests_not_arrived_yet'))
      },
      {
        data: arrivedData,
        backgroundColor: ['#23c6c8', '#23c6c8', '#23c6c8'],
        label: this.translate.instant(_('dashboard.guest_arrived'))
      },
      {
        data: rejectedButHereData,
        backgroundColor: ['#f8ac59', '#f8ac59', '#f8ac59'],
        label: this.translate.instant(_('dashboard.guest_rejected_but_here')),
      },
    ]
    };
  }

}
